// @ts-nocheck

const hasFunctionStyles = styles => {
  for (const key in styles) {
    if (Object.prototype.hasOwnProperty.call(styles, key)) {
      // @ts-ignore
      const value = styles[key];
      if (typeof value === "function") {
        return true;
      }
      if (value && typeof value === "object" && hasFunctionStyles(value)) {
        return true;
      }
    }
  }
  return false;
};

/**
 * IFL default function of shouldForwardProp. https://emotion.sh/docs/styled#customizing-prop-forwarding
 */
const shouldForwardProp = prop => {
  // IFL general props
  const generalPropNames = ["as", "sx"];

  // List of props for emotion to omit from DOM.
  const allPropNames = new Set([...generalPropNames]);
  return !allPropNames.has(prop);
};
const getDefaultThemedOptions = function () {
  for (var _len = arguments.length, styleProps = new Array(_len), _key = 0; _key < _len; _key++) {
    styleProps[_key] = arguments[_key];
  }
  const propSet = new Set([...styleProps]);
  return {
    styleProps,
    shouldForwardProp: prop => !propSet.has(prop)
  };
};
const warn = process.env.NODE_ENV !== "production" && console ? console.warn.bind(console) : function () {};

export { warn as default, getDefaultThemedOptions, hasFunctionStyles, shouldForwardProp, warn };
